<script>
export default {
  name: "notFound",
  created() {
  }
}
</script>

<template>
  <div style="display: flex;align-items: center;justify-content: center;height: 90vh;width: 90vw">
    <img src="@/assets/404/not_found.png" style="width: 60%">
  </div>
</template>

<style scoped>

</style>